// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/nav_dot_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/nav_bar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1199px) {
  .client_main {
    flex-direction: column;
  }
  .client_main .client_left {
    width: 100%;
  }
  .client_main .client_right {
    width: 100%;
  }
  .plan_results_main_outer {
    padding-top: 20px;
  }
  .main-content-wrapper-inner.report-content {
    margin-left: 0px !important;
  }
}
@media (max-width: 991px) {
  /* REPORTS_RESPONSIVE_CSS_START */
  .insured_main_outer .row.personal_div_first_row {
    padding-bottom: 10px;
  }
  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {
    color: #000000;
    padding: 0;
    text-align: center;
    border: 1px solid transparent;
  }
  .personal_div_first_row .personal_div_first_content {
    justify-content: flex-start;
  }
  .insured_main_outer .row {
    padding-bottom: 25px;
    row-gap: 10px;
  }
  .insured_main_outer .row.label_row {
    row-gap: 0px;
    padding-bottom: 0px;
  }
  .product_left_content .Select_account_main_outer .button-group {
    padding-top: 5px;
  }
  .main-content-wrapper-reports .reports_pdf_nav_tab {
    width: 100%;
    height: auto;
  }
  .main-content-wrapper-reports .reports_pdf_nav_tab ul li {
    padding: 5px 20px;
    margin-bottom: 0px;
    width: 100%;
    max-width: 85px;
    min-width: 85px;
  }
  .main-content-wrapper-reports .reports_pdf_nav_tab ul {
    display: flex;
    display: -webkit-flex;
    margin: 0px;
    padding: 15px 0px;
  }
  .Under_Management_content {
    display: flex;
    display: -webkit-flex;
  }
  .home_main_card_outer {
    width: 100% !important;
  }
  .select_client_outer {
    margin-top: 10px;
    width: 100%;
    float: none;
  }
  .navbar-right-top {
    row-gap: 15px;
    padding: 20px 0px 30px;
  }
  .nav-left-sidebar .container-fluid {
    padding: 0px;
  }
  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {
    width: 100%;
    font-size: 12px;
  }
  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus, .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link.active {
    background-color: #ffffff;
    color: #3e9479;
    border: 1px solid rgba(253, 255, 136, 0.5);
  }
  .navbar-right-top .nav-item:first-child {
    border-right: 0px solid #e6e6f2;
  }
  .sidebar-dark {
    background: #ffffff;
    background-color: #ffffff;
    box-shadow: none;
  }
  .master-main-wrapper {
    position: fixed;
    z-index: 999;
    background: #fff;
    right: 0px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.26);
  }
  .main-content-wrapper {
    z-index: 9;
    padding-top: 60px;
  }
  .nav-left-sidebar .navbar-nav {
    padding: 15px;
    flex-direction: column !important;
    flex-wrap: nowrap;
    column-gap: 15px;
    justify-content: center;
    left: -127px;
  }
  .main-header .navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    filter: invert(1);
  }
  .nav-left-sidebar .navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    filter: invert(1);
  }
  .Expenses_div_main_otr {
    padding-right: 15px;
  }
  .Current_Target_main_div {
    width: 100%;
    padding-top: 15px;
  }
}
@media (max-width: 840px) {
  .plan_results_main_outer {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
  .plan_results_main_outer .button_meter_outer-alert {
    grid-column: 1;
    grid-row: auto;
    order: 3;
  }
  .plan_results_main_outer .button_meter_outer {
    grid-column: 1;
    grid-row: auto;
    order: 1;
  }
  .client_main_right .client_main_right_2 {
    grid-column: 1;
    grid-row: auto;
    order: 2;
  }
}
@media (max-width: 768px) {
  .card.timeline-card .card-header {
    padding-top: 65px;
  }
  .h-100 {
    height: auto !important;
  }
  .Insurance_div {
    height: auto !important;
    overflow: auto;
  }
  .card .card-header {
    flex-direction: column;
    row-gap: 15px;
  }
  .select_client_outer_form_row.marketandasset_oute {
    flex-direction: column;
    row-gap: 15px;
  }
  .plan_results_main_outer .button_meter_outer {
    width: 100%;
  }
  .client_main_right .client_main_right_2 {
    border-left: 0px dotted #ababab;
    width: 100%;
    margin: 0 auto;
  }
  .client_chart_main_div .client_chart_inner {
    margin-bottom: 10px;
    padding: 5px;
  }
  .Table_main_outer table.small-width-table {
    min-width: 100%;
  }
  .chart_filter ul {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  .plan_results_main_outer {
    flex-direction: column;
    row-gap: 20px;
  }
  .plan_results_main_outer .chart_filter {
    width: 100%;
  }
  .plan_results_main_outer {
    padding-top: 0px;
  }
  .select_product_table_main_outer .select_product_table_inner:not(:last-child) {
    border-bottom: 1px solid #ddd;
    margin-bottom: 30px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    flex-direction: row;
    column-gap: 10px;
  }
  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_content p.value {
    width: 100%;
    height: auto;
  }
  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_content p {
    min-height: auto;
    height: auto;
  }
  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_amount {
    margin-left: auto;
  }
  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_content {
    width: 100%;
    height: auto;
  }
  .select_product_table_main_outer .select_product_table_inner .select_product_table_content {
    column-gap: 10px;
  }
  .select_product_main_outer {
    column-gap: 10px;
  }
  .client_contact_recency_inner.desktop .Select_state_outer {
    display: none;
  }
}
@media (max-width: 767px) {
  .market_forecast_box .box_title {
    width: 100%;
  }
  .market_forecast_box .market_forecast_box_outer {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .market_forecast_box .box_item:first-child {
    grid-column: 3 span;
    max-width: 32.8%;
  }
}
@media (max-width: 640px) {
  .Select_account_main_outer .controls-select > .MuiFormControl-root {
    flex-direction: column;
  }
  .product_left_content .Select_account_main_outer .button-group {
    padding-top: 35px;
  }
  .market_forecast_box .market_forecast_box_outer {
    grid-template-columns: 1fr 1fr;
  }
  .market_forecast_box .box_item:first-child {
    grid-column: 2 span;
    max-width: 49.5%;
  }
  .signup-body-container .newplan-form-grid .MuiGrid-root.MuiGrid-item {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }
  .Current_Target_main_div {
    flex-direction: column;
    row-gap: 10px;
  }
  .inv-list-container .MuiFormGroup-root {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .amounts_main_outer {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .market_forecast_box .box_item {
    padding: 6px 2px 6px;
  }
  .client_left .chart_filter ul {
    flex-wrap: wrap;
    align-items: center;
    row-gap: 10px;
  }
  .planOuter .select_client_outer.select_client_outer_other {
    width: 80%;
  }
  .Simulate_button_group button {
    font-size: 12px;
  }
  .Simulate_button_group button img {
    height: 12px;
  }
  .chart_filter ul li button {
    max-width: unset;
    min-width: auto;
  }
  .plaid-container .inv-list-container .MuiFormGroup-root {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 15px;
  }
  .plaid-container .inv-list-container {
    padding-left: 6px;
  }
  .client_main_right .client_main_right_left .result_scroll_div {
    width: 100%;
  }
  .client_chart_inner .Table_main_outer {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .Table_main_outer table.full-width-table {
    white-space: nowrap;
  }
  .Select_account_main_outer .controls-select-main-outer .controls-select {
    width: 100%;
  }
  .main_build_nav_item .main_build_nav_icon img {
    width: 50px;
    min-width: 50px;
    min-height: 50px;
    height: 50px;
  }
}
@media (max-width: 576px) {
  .insured_main_outer .market_data_row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
  }
  .amounts_main_outer {
    grid-template-columns: 1fr 1fr;
  }
  .client_contact_recency_inner .Under_Management_content_left {
    width: 25%;
    float: left;
  }
  .client_contact_recency_inner .Under_Management .Under_Management_content_right {
    text-align: left;
    width: 25%;
    float: left;
  }
  .Under_Management .Under_Management_image {
    margin-bottom: 20px;
  }
  .Simulate_button_group {
    flex-direction: row;
    row-gap: 5px;
  }
  .main-header .navbar-nav li.log_out button,
  .main-header .navbar-nav li.log_out {
    padding-right: 0px;
  }
  .main-header .navbar-nav li.feedback button span {
    font-size: 9px;
  }
  .master-main-wrapper .navbar-nav li button {
    padding: 2px;
  }
  .nav-left-sidebar .navbar-nav {
    column-gap: 10px;
  }
  .plan_results_main_outer {
    display: flex;
    display: -webkit-flex;
  }
  .plan_results_main_outer {
    row-gap: 5px;
  }
  .client_main_right .client_main_right_left {
    row-gap: 5px;
  }
  .plaid-container .inv-list-container .MuiFormGroup-root {
    grid-template-columns: repeat(1, 1fr);
  }
  .plaid-container .asset-mix-input {
    grid-template-columns: repeat(1, 1fr);
  }
  .action-button {
    width: 35px !important;
  }
  .residence_taxFiling_outer {
    grid-template-columns: 1fr;
  }
  .insured_main_outer .residence_taxFiling_outer_first_row {
    padding-bottom: 0px;
  }
  .Select_account_main_outer .controls-select-main-outer {
    flex-direction: column;
  }
  .main_build_nav_item .main_build_nav_icon img {
    width: 40px;
    min-width: 40px;
    min-height: 40px;
    height: 40px;
  }
}
@media (max-width: 420px) {
  .main_build_nav_item .main_build_nav_icon img {
    width: 30px;
    min-width: 30px;
    min-height: 30px;
    height: 30px;
  }
  .market_forecast_box .market_forecast_box_outer {
    grid-template-columns: 1fr;
  }
  .market_forecast_box .box_item:first-child {
    grid-column: 1 span;
    max-width: 100%;
  }
  .select_client_outer .select_client_outer_form_row {
    flex-direction: column;
    row-gap: 10px;
  }
  .select_client_outer .select2-container {
    width: 100% !important;
  }
  .select_client_outer .select_client_outer_form_row .date_picker input.form-control {
    width: 100%;
  }
  .reminder_div {
    flex-direction: column;
  }
  .action-button {
    width: 27px !important;
  }
  .main_build_nav_item {
    column-gap: 15px;
  }
}
@media (max-width: 375px) {
  .market_forecast_box .box_item {
    width: 100%;
  }
  .amounts_main_outer {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAA;EACF;EACA;IACE,WAAA;EACF;EACA;IACE,WAAA;EACF;EACA;IACE,iBAAA;EACF;EACA;IACE,2BAAA;EACF;AACF;AAKA;EACE,iCAAA;EACA;IACE,oBAAA;EAHF;EAKA;IACE,cAAA;IACA,UAAA;IACA,kBAAA;IACA,6BAAA;EAHF;EAKA;IACE,2BAAA;EAHF;EAKA;IACE,oBAAA;IACA,aAAA;EAHF;EAKA;IACE,YAAA;IACA,mBAAA;EAHF;EAKA;IACE,gBAAA;EAHF;EAKA;IACE,WAAA;IACA,YAAA;EAHF;EAKA;IACE,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EAHF;EAKA;IACE,aAAA;IACA,qBAAA;IACA,WAAA;IACA,iBAAA;EAHF;EAKA;IACE,aAAA;IACA,qBAAA;EAHF;EAKA;IACE,sBAAA;EAHF;EAKA;IACE,gBAAA;IACA,WAAA;IACA,WAAA;EAHF;EAKA;IACE,aAAA;IACA,sBAAA;EAHF;EAKA;IACE,YAAA;EAHF;EAKA;IACE,WAAA;IACA,eAAA;EAHF;EAKA;IACE,yBAAA;IACA,cAAA;IACA,0CAAA;EAHF;EAKA;IACE,+BAAA;EAHF;EAKA;IACE,mBAAA;IACA,yBAAA;IACA,gBAAA;EAHF;EAKA;IACE,eAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,0CAAA;EAHF;EAKA;IACE,UAAA;IACA,iBAAA;EAHF;EAKA;IACE,aAAA;IACA,iCAAA;IACA,iBAAA;IACA,gBAAA;IACA,uBAAA;IACA,YAAA;EAHF;EAKA;IACE,yDAAA;IACA,iBAAA;EAHF;EAKA;IACE,yDAAA;IACA,iBAAA;EAHF;EAKA;IACE,mBAAA;EAHF;EAKA;IACE,WAAA;IACA,iBAAA;EAHF;AACF;AAOA;EACE;IACE,0BAAA;IACA,wBAAA;EALF;EAOA;IACE,cAAA;IACA,cAAA;IACA,QAAA;EALF;EAOA;IACE,cAAA;IACA,cAAA;IACA,QAAA;EALF;EAOA;IACE,cAAA;IACA,cAAA;IACA,QAAA;EALF;AACF;AASA;EACE;IACE,iBAAA;EAPF;EASA;IACE,uBAAA;EAPF;EAUA;IACE,uBAAA;IACA,cAAA;EARF;EAUA;IACE,sBAAA;IACA,aAAA;EARF;EAUA;IACE,sBAAA;IACA,aAAA;EARF;EAUA;IACE,WAAA;EARF;EAUA;IACE,+BAAA;IACA,WAAA;IACA,cAAA;EARF;EAUA;IACE,mBAAA;IACA,YAAA;EARF;EAUA;IACE,eAAA;EARF;EAUA;IACE,aAAA;IACA,sCAAA;EARF;EAUA;IACE,sBAAA;IACA,aAAA;EARF;EAUA;IACE,WAAA;EARF;EAUA;IACE,gBAAA;EARF;EAUA;IACE,6BAAA;IACA,mBAAA;IACA,oBAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;EARF;EAUA;IACE,WAAA;IACA,YAAA;EARF;EAUA;IACE,gBAAA;IACA,YAAA;EARF;EAUA;IACE,iBAAA;EARF;EAUA;IACE,WAAA;IACA,YAAA;EARF;EAUA;IACE,gBAAA;EARF;EAUA;IACE,gBAAA;EARF;EAUA;IACE,aAAA;EARF;AACF;AAWA;EACE;IACE,WAAA;EATF;EAWA;IACE,kCAAA;EATF;EAWA;IACE,mBAAA;IACA,gBAAA;EATF;AACF;AAYA;EACE;IACE,sBAAA;EAVF;EAYA;IACE,iBAAA;EAVF;EAYA;IACE,8BAAA;EAVF;EAYA;IACE,mBAAA;IACA,gBAAA;EAVF;EAYA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;EAVF;EAYA;IACE,sBAAA;IACA,aAAA;EAVF;EAYA;IACE,aAAA;IACA,qCAAA;EAVF;EAYA;IACE,kCAAA;EAVF;EAYA;IACE,oBAAA;EAVF;EAaA;IACE,eAAA;IACA,mBAAA;IACA,aAAA;EAXF;EAaA;IACE,UAAA;EAXF;EAaA;IACE,eAAA;EAXF;EAaA;IACE,YAAA;EAXF;EAaA;IACE,gBAAA;IACA,eAAA;EAXF;EAaA;IACE,qCAAA;IACA,mBAAA;EAXF;EAaA;IACE,iBAAA;EAXF;EAaA;IACE,WAAA;EAXF;EAaA;IACE,gBAAA;IACA,iCAAA;EAXF;EAcA;IACE,mBAAA;EAZF;EAcA;IACE,WAAA;EAZF;EAcA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;EAZF;AACF;AAeA;EACE;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;EAbF;EAeA;IACE,8BAAA;EAbF;EAeA;IACE,UAAA;IACA,WAAA;EAbF;EAeA;IAGE,gBAAA;IACA,UAAA;IACA,WAAA;EAfF;EAiBA;IACE,mBAAA;EAfF;EAiBA;IACE,mBAAA;IACA,YAAA;EAfF;EAiBA;;IAEE,kBAAA;EAfF;EAiBA;IACE,cAAA;EAfF;EAiBA;IACE,YAAA;EAfF;EAiBA;IACE,gBAAA;EAfF;EAiBA;IACE,aAAA;IACA,qBAAA;EAfF;EAiBA;IACE,YAAA;EAfF;EAiBA;IACE,YAAA;EAfF;EAiBA;IACE,qCAAA;EAfF;EAiBA;IACE,qCAAA;EAfF;EAiBA;IACE,sBAAA;EAfF;EAiBA;IACE,0BAAA;EAfF;EAiBA;IACE,mBAAA;EAfF;EAiBA;IACE,sBAAA;EAfF;EAiBA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;EAfF;AACF;AAkBA;EACE;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;EAhBF;EAkBA;IACE,0BAAA;EAhBF;EAkBA;IACE,mBAAA;IACA,eAAA;EAhBF;EAkBA;IACE,sBAAA;IACA,aAAA;EAhBF;EAkBA;IACE,sBAAA;EAhBF;EAkBA;IAIE,WAAA;EAnBF;EAqBA;IACE,sBAAA;EAnBF;EAqBA;IACE,sBAAA;EAnBF;EAqBA;IACE,gBAAA;EAnBF;AACF;AAsBA;EACE;IACE,WAAA;EApBF;EAsBA;IACE,0BAAA;EApBF;AACF","sourcesContent":["@media (max-width: 1199px) {\r\n  .client_main {\r\n    flex-direction: column;\r\n  }\r\n  .client_main .client_left {\r\n    width: 100%;\r\n  }\r\n  .client_main .client_right {\r\n    width: 100%;\r\n  }\r\n  .plan_results_main_outer {\r\n    padding-top: 20px;\r\n  }\r\n  .main-content-wrapper-inner.report-content {\r\n    margin-left: 0px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  /* REPORTS_RESPONSIVE_CSS_START */\r\n  .insured_main_outer .row.personal_div_first_row {\r\n    padding-bottom: 10px;\r\n  }\r\n  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {\r\n    color: #000000;\r\n    padding: 0;\r\n    text-align: center;\r\n    border: 1px solid transparent;\r\n  }\r\n  .personal_div_first_row .personal_div_first_content {\r\n    justify-content: flex-start;\r\n  }\r\n  .insured_main_outer .row {\r\n    padding-bottom: 25px;\r\n    row-gap: 10px;\r\n  }\r\n  .insured_main_outer .row.label_row {\r\n    row-gap: 0px;\r\n    padding-bottom: 0px;\r\n  }\r\n  .product_left_content .Select_account_main_outer .button-group {\r\n    padding-top: 5px;\r\n  }\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab ul li {\r\n    padding: 5px 20px;\r\n    margin-bottom: 0px;\r\n    width: 100%;\r\n    max-width: 85px;\r\n    min-width: 85px;\r\n  }\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab ul {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n    margin: 0px;\r\n    padding: 15px 0px;\r\n  }\r\n  .Under_Management_content {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n  }\r\n  .home_main_card_outer {\r\n    width: 100% !important;\r\n  }\r\n  .select_client_outer {\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    float: none;\r\n  }\r\n  .navbar-right-top {\r\n    row-gap: 15px;\r\n    padding: 20px 0px 30px;\r\n  }\r\n  .nav-left-sidebar .container-fluid {\r\n    padding: 0px;\r\n  }\r\n  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {\r\n    width: 100%;\r\n    font-size: 12px;\r\n  }\r\n  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus, .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link.active {\r\n    background-color: #ffffff;\r\n    color: #3e9479;\r\n    border: 1px solid rgba(253, 255, 136, 0.5);\r\n  }\r\n  .navbar-right-top .nav-item:first-child {\r\n    border-right: 0px solid #e6e6f2;\r\n  }\r\n  .sidebar-dark {\r\n    background: #ffffff;\r\n    background-color: #ffffff;\r\n    box-shadow: none;\r\n  }\r\n  .master-main-wrapper {\r\n    position: fixed;\r\n    z-index: 999;\r\n    background: #fff;\r\n    right: 0px;\r\n    box-shadow: 0 0 12px 0 rgb(0 0 0 / 26%);\r\n  }\r\n  .main-content-wrapper {\r\n    z-index: 9;\r\n    padding-top: 60px;\r\n  }\r\n  .nav-left-sidebar .navbar-nav {\r\n    padding: 15px;\r\n    flex-direction: column !important;\r\n    flex-wrap: nowrap;\r\n    column-gap: 15px;\r\n    justify-content: center;\r\n    left: -127px;\r\n  }\r\n  .main-header .navbar-light .navbar-toggler-icon {\r\n    background-image: url('../images/nav_dot_icon.svg');\r\n    filter: invert(1);\r\n  }\r\n  .nav-left-sidebar .navbar-light .navbar-toggler-icon {\r\n    background-image: url('../images/nav_bar.svg');\r\n    filter: invert(1);\r\n  }\r\n  .Expenses_div_main_otr {\r\n    padding-right: 15px;\r\n  }\r\n  .Current_Target_main_div {\r\n    width: 100%;\r\n    padding-top: 15px;\r\n  }\r\n  \r\n}\r\n\r\n@media (max-width: 840px) {\r\n  .plan_results_main_outer {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: auto;\r\n  }\r\n  .plan_results_main_outer .button_meter_outer-alert {\r\n    grid-column: 1;\r\n    grid-row: auto;\r\n    order: 3;\r\n  }\r\n  .plan_results_main_outer .button_meter_outer {\r\n    grid-column: 1;\r\n    grid-row: auto;\r\n    order: 1;\r\n  }\r\n  .client_main_right .client_main_right_2 {\r\n    grid-column: 1;\r\n    grid-row: auto;\r\n    order: 2;\r\n  }\r\n  \r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .card.timeline-card .card-header {\r\n    padding-top: 65px;\r\n  }\r\n  .h-100 {\r\n    height: auto !important;\r\n  }\r\n\r\n  .Insurance_div {\r\n    height: auto !important;\r\n    overflow: auto;\r\n  }\r\n  .card .card-header {\r\n    flex-direction: column;\r\n    row-gap: 15px;\r\n  }\r\n  .select_client_outer_form_row.marketandasset_oute {\r\n    flex-direction: column;\r\n    row-gap: 15px;\r\n  }\r\n  .plan_results_main_outer .button_meter_outer {\r\n    width: 100%;\r\n  }\r\n  .client_main_right .client_main_right_2 {\r\n    border-left: 0px dotted #ababab;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n  }\r\n  .client_chart_main_div .client_chart_inner {\r\n    margin-bottom: 10px;\r\n    padding: 5px;\r\n  }\r\n  .Table_main_outer table.small-width-table {\r\n    min-width: 100%;\r\n  }\r\n  .chart_filter ul {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  }\r\n  .plan_results_main_outer {\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n  }\r\n  .plan_results_main_outer .chart_filter {\r\n    width: 100%;\r\n  }\r\n  .plan_results_main_outer {\r\n    padding-top: 0px;\r\n  }\r\n  .select_product_table_main_outer .select_product_table_inner:not(:last-child) {\r\n    border-bottom: 1px solid #ddd;\r\n    margin-bottom: 30px;\r\n    padding-bottom: 20px;\r\n    flex-wrap: wrap;\r\n    flex-direction: row;\r\n    column-gap: 10px;\r\n  }\r\n  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_content p.value {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_content p {\r\n    min-height: auto;\r\n    height: auto;\r\n  }\r\n  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_amount {\r\n    margin-left: auto;\r\n  }\r\n  .select_product_table_main_outer .select_product_table_inner:not(:last-child) .select_product_table_content {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .select_product_table_main_outer .select_product_table_inner .select_product_table_content {\r\n    column-gap: 10px;\r\n  }\r\n  .select_product_main_outer {\r\n    column-gap: 10px;\r\n  }\r\n  .client_contact_recency_inner.desktop .Select_state_outer {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .market_forecast_box .box_title {\r\n    width: 100%;\r\n  }\r\n  .market_forecast_box .market_forecast_box_outer {\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n  .market_forecast_box .box_item:first-child {\r\n    grid-column: 3 span;\r\n    max-width: 32.8%;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .Select_account_main_outer .controls-select > .MuiFormControl-root {\r\n    flex-direction: column;\r\n  }\r\n  .product_left_content .Select_account_main_outer .button-group {\r\n    padding-top: 35px;\r\n  }\r\n  .market_forecast_box .market_forecast_box_outer {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .market_forecast_box .box_item:first-child {\r\n    grid-column: 2 span;\r\n    max-width: 49.5%;\r\n  }\r\n  .signup-body-container .newplan-form-grid .MuiGrid-root.MuiGrid-item {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    flex-basis: 100%;\r\n  }\r\n  .Current_Target_main_div {\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n  }\r\n  .inv-list-container .MuiFormGroup-root {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  .amounts_main_outer {\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n  .market_forecast_box .box_item {\r\n    padding: 6px 2px 6px;\r\n  }\r\n  \r\n  .client_left .chart_filter ul {\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    row-gap: 10px;\r\n  }\r\n  .planOuter .select_client_outer.select_client_outer_other {\r\n    width: 80%;\r\n  }\r\n  .Simulate_button_group button {\r\n    font-size: 12px;\r\n  }\r\n  .Simulate_button_group button img {\r\n    height: 12px;\r\n  }\r\n  .chart_filter ul li button {\r\n    max-width: unset;\r\n    min-width: auto;\r\n  }\r\n  .plaid-container .inv-list-container .MuiFormGroup-root {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    margin-bottom: 15px;\r\n  }\r\n  .plaid-container .inv-list-container {\r\n    padding-left: 6px;\r\n  }\r\n  .client_main_right .client_main_right_left .result_scroll_div {\r\n    width: 100%;\r\n  }\r\n  .client_chart_inner .Table_main_outer {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n\r\n  }\r\n  .Table_main_outer table.full-width-table {\r\n    white-space: nowrap;\r\n  }\r\n  .Select_account_main_outer .controls-select-main-outer .controls-select {\r\n    width: 100%;\r\n  }\r\n  .main_build_nav_item .main_build_nav_icon img {\r\n    width: 50px;\r\n    min-width: 50px;\r\n    min-height: 50px;\r\n    height: 50px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .insured_main_outer .market_data_row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    column-gap: 10px;\r\n  }\r\n  .amounts_main_outer {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .client_contact_recency_inner .Under_Management_content_left {\r\n    width: 25%;\r\n    float: left;\r\n  }\r\n  .client_contact_recency_inner\r\n    .Under_Management\r\n    .Under_Management_content_right {\r\n    text-align: left;\r\n    width: 25%;\r\n    float: left;\r\n  }\r\n  .Under_Management .Under_Management_image {\r\n    margin-bottom: 20px;\r\n  }\r\n  .Simulate_button_group {\r\n    flex-direction: row;\r\n    row-gap: 5px;\r\n  }\r\n  .main-header .navbar-nav li.log_out button, \r\n  .main-header .navbar-nav li.log_out {\r\n    padding-right: 0px;\r\n  }\r\n  .main-header .navbar-nav li.feedback button span {\r\n    font-size: 9px;\r\n  }\r\n  .master-main-wrapper .navbar-nav li button {\r\n    padding: 2px;\r\n  }\r\n  .nav-left-sidebar .navbar-nav {\r\n    column-gap: 10px;\r\n  }\r\n  .plan_results_main_outer {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n  }\r\n  .plan_results_main_outer {\r\n    row-gap: 5px;\r\n  }\r\n  .client_main_right .client_main_right_left {\r\n    row-gap: 5px;\r\n  }\r\n  .plaid-container .inv-list-container .MuiFormGroup-root {\r\n    grid-template-columns: repeat(1, 1fr);\r\n  }\r\n  .plaid-container .asset-mix-input {\r\n    grid-template-columns: repeat(1, 1fr);\r\n  }\r\n  .action-button {\r\n    width: 35px !important;\r\n  }\r\n  .residence_taxFiling_outer {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .insured_main_outer .residence_taxFiling_outer_first_row {\r\n    padding-bottom: 0px;\r\n  }\r\n  .Select_account_main_outer .controls-select-main-outer {\r\n    flex-direction: column;\r\n  }\r\n  .main_build_nav_item .main_build_nav_icon img {\r\n    width: 40px;\r\n    min-width: 40px;\r\n    min-height: 40px;\r\n    height: 40px;\r\n  }\r\n}\r\n\r\n@media (max-width: 420px) {\r\n  .main_build_nav_item .main_build_nav_icon img {\r\n    width: 30px;\r\n    min-width: 30px;\r\n    min-height: 30px;\r\n    height: 30px;\r\n  }\r\n  .market_forecast_box .market_forecast_box_outer {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .market_forecast_box .box_item:first-child {\r\n    grid-column: 1 span;\r\n    max-width: 100%;\r\n  }\r\n  .select_client_outer .select_client_outer_form_row {\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n  }\r\n  .select_client_outer .select2-container {\r\n    width: 100% !important;\r\n  }\r\n  .select_client_outer\r\n    .select_client_outer_form_row\r\n    .date_picker\r\n    input.form-control {\r\n    width: 100%;\r\n  }\r\n  .reminder_div {\r\n    flex-direction: column; \r\n  }\r\n  .action-button {\r\n    width: 27px !important;\r\n  }\r\n  .main_build_nav_item {\r\n    column-gap: 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 375px) {\r\n  .market_forecast_box .box_item {\r\n    width: 100%;\r\n  }\r\n  .amounts_main_outer {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
